//@ts-nocheck
import {Column} from 'react-table'
import {OwnerNameCell} from './OwnerNameCell'
import {OwnerDocCell} from './OwnerDocCell'
import {OwnerEmailCell} from './OwnerEmailCell'
import {OwnerCustomHeader} from './OwnerCustomHeader'
import {OwnerActionsCell} from './OwnerActionsCell'
import {Owner} from '../../core/_models'

const OwnerColumns: ReadonlyArray<Column<Owner>> = [
  {
    Header: (props) => (
      <OwnerCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='text-right min-w-125px'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <OwnerNameCell owner={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <OwnerCustomHeader
        tableProps={props}
        title='COMMON.INPUT_CNPJ'
        className='text-right min-w-125px'
      />
    ),
    id: 'document',
    Cell: ({...props}) => <OwnerDocCell owner={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <OwnerCustomHeader
        tableProps={props}
        title='COMMON.INPUT_EMAIL'
        className='text-right min-w-125px'
      />
    ),
    id: 'email',
    Cell: ({...props}) => <OwnerEmailCell owner={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <OwnerCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='text-center min-w-100px '
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <OwnerActionsCell data={props.data[props.row.index]} />,
  },
]

export {OwnerColumns}
